import React from "react";
import _ from "lodash";
import CourtAppointment from "./CourtAppointment";
import { Box } from "@mui/material";
import { scrollToAnchor } from "../../theme/commonStyles";

import { ProductUnion } from "../../types/ProductUnion";

type CourtAppointmentsProps = {
  product: ProductUnion;
  refreshPage: () => void;
};
const CourtAppointments = ({ product, refreshPage }: CourtAppointmentsProps) => {
  return (
    <>
      <Box sx={scrollToAnchor} id={"courtAppointments"} />
      {_.map(
        _.sortBy(product.courtAppointments, (c) => -c.id),
        (courtAppointment, index) => (
          <CourtAppointment
            key={index}
            headline={"Gerichtstermin"}
            product={product}
            courtAppointment={courtAppointment}
            refreshPage={refreshPage}
          />
        )
      )}
    </>
  );
};
export default CourtAppointments;
